import { useUserStore } from "@/pinia/userStore";

/**
 * Route guard for audits page - requires base super_admin role
 * (not acting super_admin)
 */
export const auditsGuard = async (to, from) => {
  const userStore = useUserStore();
  // Ensure user data is loaded
  if (!userStore.currUser?.id) {
    await userStore.getUser();
  }
  if (userStore.isUserSuperAdmin) {
    return true;
  } else {
    return { name: "Home" };
  }
};
